import { useContext } from 'react'

import LoadingScreen from '../../../components/elements/loading/loading-screen'
import { ForeignStaffTravelSchedulePage } from '../../../components/pages/staff-personal-space/travel-schedule/foreign-staff-travel-schedule-page'
import { FrenchStaffTravelSchedulePage } from '../../../components/pages/staff-personal-space/travel-schedule/french-staff-travel-schedule-page'
import { AffectedStaffContext } from '../../../lib/contexts/affected-staff'
import { AffectedStaffProperties } from '../../../lib/types/models/affectedStaff/properties.affected-staff'

export function StaffPersonalSpaceTravel() {
  const { affectedStaff } = useContext(AffectedStaffContext)

  const isFrench = AffectedStaffProperties.isFrench(affectedStaff)

  if (!affectedStaff) return <LoadingScreen />
  if (isFrench) return <FrenchStaffTravelSchedulePage data={affectedStaff} />
  return <ForeignStaffTravelSchedulePage data={affectedStaff} />
}
